// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"Layout_layoutContainer__1vej6","extendedLogoContainer":"Layout_extendedLogoContainer__1Ps6M"};